<template>
  <div>
    <div class="Bid-page" v-loading="loadingflag">
      <div class="big-flex">
        <div class="bid-box" style="margin-top: 25px;">
          <el-tabs class="tabs-box" v-model="form.Type" type="card" @tab-click="handTab">
            <el-tab-pane label="可参与的" name="1"></el-tab-pane>
            <el-tab-pane label="历史参与" name="2"></el-tab-pane>
            <el-tab-pane label="历史成交" name="3"></el-tab-pane>
          </el-tabs>
          <div class="bid-list">
            <ul class="clearfix bid-list-ul">
              <li v-for="(item,index) in bidList" :key="index">
                <div class="bid-img-box">
                  <!--<img src="/static/images/list/汽油.png">-->
                  <img  style="width: 100%;" :src="headImg+item.ProductImg" alt="">
                  <!--<div class="absolute-status">-->
                  <!--<p v-if="item.Status == 0">待发布</p>-->
                  <!--<p v-if="item.Status == 1">未开始</p>-->
                  <!--<p v-if="item.Status == 2">已开始</p>-->
                  <!--<p v-if="item.Status == 3">已完成</p>-->
                  <!--</div>-->
                  <div v-if="item.Status == 1" class="join-status">
                    <img src="/static/images/bid/dks.png">
                  </div>
                  <div v-if="item.Status == 2" class="join-status">
                    <img src="/static/images/bid/jxz.png">
                  </div>
                  <div v-if="item.Status == 3" class="join-status">
                    <img src="/static/images/bid/yjs.png">
                  </div>
                </div>
                <div class="bid-info">
                  <div class="bin-info-title">
                    <div><img src="/static/images/bid/bidbuy_biao.png"></div>
                    <span>{{ item.ProductName}}</span>
                  </div>
                  <!--TODO 240514-->
                  <p>
                    <i class="el-icon-shopping-cart-2"></i>
                    <span class="span-label"><span style="display: inline-block;background: #990055;color: white;padding: 2px;">竞采量</span>：</span><span class="span-value">{{item.AutionNum.toFixed(2)}}吨</span>
                  </p>
                  <!--<p><i class="el-icon-timer"></i>-->
                  <!--<span class="span-label">倒计时：</span><span class="span-value" style="color: red;">{{ item.djs}}</span></p>-->
                  <p>
                    <i class="el-icon-timer"></i>
                    <span class="span-label">起始时间：</span><span class="span-value">{{item.AutionStartTime?item.AutionStartTime.replace(/T/,' '):''}} — {{item.AutionEndTime?item.AutionEndTime.replace(/T/,' '):''}}</span>
                  </p>
                </div>

                <button class="bid-button" @click="turnTo('/Menu/BidBuyDetail',item)">{{item.Status==3? '查看':item.IsJoinIn?'已参与':'参与'}}</button>
              </li>
              <el-pagination
                class="page-sty"
                background
                layout="prev, pager, next"
                size="mini"
                @current-change="handleCurrentChange"
                :total="total">
              </el-pagination>
            </ul>
          </div>
          <div style="margin-top: 20px;text-align: center;background: #fff;padding: 20px 0px;">
            <!--<p style="font-size: 16px;font-weight: 600;">监督服务电话：{{1888888888}}</p>-->
          </div>
        </div>
        <div class="news-box">
          <div class="news-box-c">
            <p class="title-c"><span>招标公告</span><span class="more" @click="getMore">更多</span></p>
            <div class="news-list-li">
              <ul>
                <li v-for="(item,index) in newsList" :key="index">
                  <p style="cursor: pointer;" @click="downloadIt(item)">[{{ item.F_CreateTime.substring(0,10) }}]&nbsp;&nbsp;{{ item.F_Title }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
    <el-dialog  center
                title="最新竞采信息"
                :visible.sync="dialogVisible" :close-on-click-modal="false">
      <div v-html="newDialog"></div>
      <div slot="footer" class="dialog-footer">
        <el-button type="warning" @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        headImg:'',
        form:{
          MaterielId:'',
          AutionModel:'',
          IsDeposit:'',
          Type:'1',
          ProductName:''
        },
        loadingflag:false,
        bidList:[],
        PageIndex:1,
        total:0,
        url:{
          list:SZH.assets.api + '/AuctionPurchase/GetAuctionInfoByPaging',
          cuttent:SZH.assets.api + '/Custom/GetCurrentDateTime',
          GetListNews: SZH.assets.api + '/Market/GetListNews2',
          GetNews: SZH.assets.api + '/Market/GetCustomNews2',
          VerifyCustomGroup: SZH.assets.api + '/AuctionPurchase/VerifyCustomGroup',
        },
        currentTime:'',
        setIntervalObj:null,
        newsList:[],
        dialogVisible: false,
        newDialog:"",
        dateTime:''
      }
    },
    methods: {
      turnTo(url,bid){
        let self = this;
        if(bid) {
          if(bid.IsJoinIn){
            let routeData = self.$router.push({
              path: url,
              query:{ id: bid.Id}
            });
          }else{
            self.$http.post(self.url.VerifyCustomGroup,{
              data:bid.Id
            }).then(result =>{
              if(result.state == true){
                let routeData = self.$router.push({
                  path: url,
                  query:{ id: bid.Id}
                });
              }else{
                self.$message.error(result.message)
              }
            }, () => {
            });
          }
        }
        else {
          self.$router.push({
            path: url
          })
        }
      },
      handleCurrentChange(val){
        this.PageIndex = val;
        this.getBidList();
      },
      handTab(){
        let that = this;
        that.PageIndex = 1;
        that.getBidList();
      },
      getBidList(){
        let self = this;
        self.$http.post(self.url.list,{
          PageSize:10,
          PageIndex:self.PageIndex,
          Data:self.form
        }).then(result =>{
          if(result.state == true && result.data.Data.length>0){
            self.loadingflag =false;
            self.total = result.data.TotalCount;
            result.data.Data.map( (obj,index)=>{
              if(obj.TaskType == 1){
                self.$set(
                  obj,"djs",''
                );
              }else{
                self.$set(
                  obj,"djs",''
                );
              }

            });
            self.bidList = result.data.Data;
            //  执行倒计时
            if(self.form.Type == 1){
              // self.beginTimeFun();
            }
          }else{
            self.loadingflag =false;
            self.bidList= [];
            self.total = 0;
          }
        }, () => {
          // self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      beginTimeFun(){
        this.setIntervalObj = setInterval( ()=> {
          this.getcuttent();
          for (var key in this.bidList) {
            if(this.bidList[key]['Status'] == 2){
              var end = 0;
              if(this.bidList[key].TaskType == 1){
                end = new Date(this.bidList[key]['AutionEndTime']).getTime();
              }else{
                end = new Date(this.bidList[key]['DynamicEndTime']).getTime();
              }
              var begin = new Date(this.currentTime).getTime();
              var rightTime = end - begin;
              if (rightTime > 0) {
                var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
                var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
                var mm = Math.floor((rightTime / 1000 / 60) % 60);
                var ss = Math.floor((rightTime / 1000) % 60);
                this.bidList[key]["djs"] = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
              }else{
                this.bidList[key]["djs"] = "已结束"
              }
            }


          }
        }, 1000);
      },
      getcuttent(){
        let self = this;
        self.$http.post(self.url.cuttent,{

        }).then(result =>{
          if(result.state == true && result.data){
            self.currentTime = result.data;
          }else{
          }
        }, () => {
        });
      },
      //  公告
      GetListNewsFun() {
        let self = this;
        self.$http.post(self.url.GetListNews, {
          Count: 10
        }).then(result => {
          if (result.state == true) {
            self.newsList = result.data;
          } else {
            self.newsList = []
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      getMore() {
        this.$router.push({
          path: '/Menu/BidBuyNewsList'
        });
      },
      downloadIt(item) {
        this.$router.push({
          path: '/Menu/BidBuyNewsDetail',
          query: {
            Id: item.F_Id
          }
        });
      },
      //弹窗所用数据
      loadNewsDetail(){
        let self = this;
        self.$http.post(self.url.GetNews,{
          keyValue:""
        }).then(result=>{
          if(result.state == true && result.data){
            //判断时间
            self.getDate();
            if(result.data.F_StartTime && result.data.F_EndTime){
              let newStartTime = result.data.F_StartTime.replaceAll("T"," " );
              let newEndTime = result.data.F_EndTime.replaceAll("T"," " );
              if(self.dateTime<newStartTime || self.dateTime >newEndTime){
                self.dialogVisible = false;
                self.newDialog =  ''
              }else{
                self.dialogVisible = true;
                self.newDialog = result.data.F_Content

              }
            }
          }else{
            console.log(result.message)
          }
        })
      },
      getDate(){
        let yy = new Date().getFullYear();
        let MM = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let hour = new Date().getHours();
        let minutes = new Date().getMinutes();
        let seconds = new Date().getSeconds();

        if (MM < 10) {
          MM = '0' + MM
        }
        if (dd < 10) {
          dd = '0' + dd
        }
        let hh = hour < 10 ? '0' + hour : hour;
        let mm = minutes < 10 ? '0' + minutes : minutes;
        let ss = seconds < 10 ? '0' + seconds : seconds;
        this.dateTime = yy + '-' + MM + '-' + dd + ' ' + hh + ':' + mm + ':' + ss;
      },
    },
    destroyed(){
      clearInterval(this.setIntervalObj)
    },
    computed: {

    },
    components: {},
    mounted() {
      this.headImg = SZH.assets.image;
      this.getBidList();
      this.getcuttent();
      this.GetListNewsFun();
      this.loadNewsDetail();


    }
  }
</script>
<style>
  .tabs-box .el-tabs__header .is-top{
    border: 0px;
  }
  .tabs-box .el-tabs--card>.el-tabs__header{
    border-bottom: 0px;
  }
  .tabs-box .el-tabs__item.is-active{
    color: white;
    background: #3458DE;
    /*background: #409EFF;FF6A00*/
  }
  .tabs-box .el-tabs__item:hover{
    color: #000;
  }
  .tabs-box .el-tabs__item.is-active:hover{
    color: white;
  }
</style>
<style scoped>
  .big-flex{
    display: flex;
    justify-content: space-between;
  }
  .jpgg-sc{
    display: flex;
    background: #fff;
    width: 1200px;
    padding: 5px;
  }
  .jpgg-sc-t{
    width: 60px;
    height: 60px;
    background: #3458DE;
    border-radius: 3px;
  }
  .jpgg-sc-t p{
    text-align: center;
    font-weight: 600;
    color: #fff;
    margin-top: 8px
  }
  .notice-sc{
    display:flex;
    align-items: center;
    justify-content: left;
  }
  .notice-sc li{
    flex: 1;
    text-align: center;
    line-height: 60px;
    font-size: 16px;
  }

  .page-sty{
    text-align: center;
    margin-top: 10px;
  }
  .Bid-page{
    width: 1200px;
    margin: 20px auto;
  }

  .conditions{
    background: white;
    padding: 10px 20px;
    margin-bottom: 20px;
  }
  .tabs-box{
    padding-top: 20px;
    padding-left: 20px;
  }
  .bid-box{
    /*background: white;*/
    width: 960px;
  }
  .bid-img-box{
    width: 151px;
    height: 151px;
    background: #D7D7D7;
    position: relative;
    overflow: hidden;
  }
  .bid-img-box img{
    width: 100%;
    height: 100%;
  }
  .absolute-status{
    background: rgba(0,0,0,0.6);
    position: absolute;
    width: 100%;
    left: 0px;
    bottom: 0px;
  }
  .absolute-status p{
    font-size: 14px;
    font-weight: 600;
    color: white;
    line-height: 47px;
    text-align: center;
  }
  .join-status{
    width: 60px;
    height: 60px;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .join-status img{
    width: 100%;
  }
  .bid-list{
    display: flex;
    min-height: 500px;
  }
  .bid-list ul.bid-list-ul{
    background: white;
    /*width: 920px;*/
    flex: 1;
    padding: 20px 30px;
  }
  .bid-list ul li{
    list-style: none;
    display: flex;
    align-items: center;
    padding: 20px 0px;
    border-bottom: 1px solid #ddd;
    position: relative;
  }
  .bin-info-title{
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .bid-info{
    padding-left: 20px;
  }
  .bid-info img{
    width: 32px;
    height: 32px;
  }
  .bin-info-title span{
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    margin-left: 8px;
  }
  .bid-info p{
    color: #999999;
    margin: 10px 0px;
  }
  .bid-info p i{
    font-size: 18px;
    font-weight: 600;
    margin-left: 5px;
  }
  .bid-info p span.span-label{
    width: 75px;
    text-align: right;
    display: inline-block;
    font-size: 14px;
  }
  .bid-info p span.span-value{
    font-weight: 600;
    font-size: 14px;
  }
  .bid-button-father{
    width: 240px;position: relative;
  }
  .bid-button{
    border: 0px;
    padding: 5px 30px;
    background: #FF6A00;
    color: white;
    position: absolute;
    bottom: 35px;
    right: 0px;
    cursor: pointer;
  }
  .max-min p{
    font-size: 16px;
    font-weight: 600;
    text-align: right;
    color: #999999;
    line-height: 150%;
  }
  .max-min p.max-money span{
    color:#FF6A00;
  }
  .max-min p.min-money span{
    color:#0066FF;
  }
  .bid-commont{
    width: calc(100% - 950px);
    margin-left: 30px;
    background: white;
    padding: 0px 20px;
  }
  .bid-commont h3{
    border-left: 4px solid #FF6A00;
    margin: 20px 0px;
    font-size: 18px;
    font-weight: 600;
    padding-left: 15px;
    background: white;
    margin-bottom: 10px;
  }
  .bid-commont .more{
    font-size: 14px;
    float: right;
    cursor: pointer;
    line-height: 200%;
  }
  .bid-commont ul li{
    border: 0px;
    padding: 5px 0px;
    cursor: pointer;
  }
  .bid-commont ul li:hover{
    color: #0066FF;
  }
  .bid-commont-title{
    font-size: 12px;
    line-height: 200%;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow:ellipsis;
  }
  .news-box{
    width: 230px;
    margin-top: 85px;
  }
  .news-box-c{
    background: #f5f5f5;
    padding: 10px;
  }
  .title-c{
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title-c span.more{
    color: #0441A0;
    cursor: pointer;
    font-size: 12px;
  }
  .news-list-li ul{
    margin-top: 10px;
  }
  .news-list-li ul li{
    width: 100%;
    padding: 10px 0px;
    border-top: 1px solid #ddd;
  }
  .news-list-li ul li p{
    font-size: 12px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/views/BidBuyList/BidBuyList.vue